export const ReportIssueListActors = {
    TOGGLE_REPORT_ISSUE:'TOGGLE_REPORT_ISSUE',
    REPORT_ISSUE_LIST:'REPORT_ISSUE_LIST',
    TOGGLE_PENDING_REPORT_ISSUE:'TOGGLE_PENDING_REPORT_ISSUE',
    PENDING_REPORT_ISSUE_LIST:'REPORT_PENDING_ISSUE_LIST',
    TOGGLE_RESOLVED_REPORT_ISSUE:'TOGGLE_RESOLVED_REPORT_ISSUE',
    RESOLVED_REPORT_ISSUE_LIST:'RESOLVED_REPORT_ISSUE_LIST',
    TOGGLE_DISCARDED_REPORT_ISSUE:'TOGGLE_DISCARDED_REPORT_ISSUE',
    DISCARDED_REPORT_ISSUE_LIST:'DISCARDED_REPORT_ISSUE_LIST'
}